import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AppleIcon } from '../../icons/Apple';

import { SocialButton } from './SocialButton';

interface IProps {
	onClick: VoidFunction;
}
export const AppleButton: FC<IProps> = (props) => {
	const { t } = useTranslation('socialLogin');
	const { onClick } = props;

	const handleClick = () => {
		onClick();
	};

	return (
		<SocialButton
			name="apple"
			text={t('button.apple')}
			onClick={handleClick}
			icon={<AppleIcon />}
		/>
	);
};
